import script from "./FormUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./FormUpload.vue?vue&type=script&setup=true&lang=js"

import "./FormUpload.vue?vue&type=style&index=0&id=4342557c&lang=css"

const __exports__ = script;

export default __exports__